import React, { useState, useEffect } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import {
  Grid,
  Box,
  Paper,
  Container,
  Tooltip,
  Button,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
} from "@material-ui/core";
/** Importamos los componentes de estilos del formulario lado izquierdo FORM y lado Derecho Image y descripcion* */
import GridItem from "../../Components/Grid/GridItem";
import GridContainer from "../../Components/Grid/GridContainer";
import Card from "../../Components/Card/Card";
import CardHeader from "../../Components/Card/CardHeader";
import CardAvatar from "../../Components/Card/CardAvatar";
import CardBody from "../../Components/Card/CardBody";

/**Importar Select State */
import SelectState from "./SelectState";
/**Importar Select Municipalities */
import SelectMunicipalities from "./SelectMunicipality";

/**importar spinner */
import Spinner from "../../Complements/Spinner";
import headerConfig from "../../Config/imageHeaders";
/**Importar MethodPut */
import MethodGet, { MethodPost } from "../../Config/Services";

/**Importar Sweetalert2 * */
import Swal from "sweetalert2";
/**Habilitar redirecciones */
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    //marginBottom: theme.spacing(10),
  },
  typography: {
    margin: theme.spacing(1),
    //paddingLeft: theme.spacing(30),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(9),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    background: "indigo",
    "&:hover": {
      background: "#5902CF",
    },
    color: "white",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  input: {
    display: "none",
  },
  containerImageProfile: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  PaperFormAdd: {
    background: "white",
    color: "black",
    boxShadow: "2px 4px 4px #cacaca",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
}));

function OfficeEdit(props) {
  //Trabajar con el Spinner
  const [cargando, spinnerCargando] = useState(false);

  const { id } = props.match.params; //Se toma el ID de la Sucursal a editar

  //Trabajar con el state de estado
  const [estadoId, guardarEstado] = useState({
    state_id: "",
  });
  //Trabajar con el state de Municipio
  const [municipality, guardarMunicipioId] = useState({
    municipality_id: "",
  });

  const [image, setImage] = useState({
    urlPhoto: "https://pisouniversitario.com/template/images/page-404.jpg",
    image: "",
  });

  //funcion para guardar la imagen y obtener la vista previa
  const handleChangeImage = (e) => {
    setImage({
      ...image,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  const classes = useStyles();

  // const [operator, setOperator] = useState({});
  const [branch, guardarBranch] = useState({});

  //Funcion para validaciones
  const { register, handleSubmit, errors } = useForm();

  //Funciones para almacenar el id del estado
  const detectarCambiosEstado = (e) => {
    guardarEstado({ state_id: e.target.value });
  };
  //Funciones para almacenar el id del municipio
  const detectarCambiosMunicipios = (e) => {
    guardarMunicipioId({ municipality_id: e.target.value });
  };

  //Extraer valores de branch(destructuracion)
  const { name, direction, number_phone, state_id, municipality_id } = branch;

  //Guardar los camios de la sucursal
  const onSubmit = (data, e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("direction", data.direction);
    formData.append("number_phone", data.number_phone);
    formData.append("state_id", estadoId.state_id);
    formData.append("municipality_id", municipality.municipality_id);
    if (image !== "") {
      formData.append("image", image.image);
    }
    formData.append("_method", "PATCH");

    let url = `/branches/${id}`;
    MethodPost(url, formData, { headerConfig })
      .then((res) => {
        Swal.fire({
          title: "Sucursal editada exitosamente",
          text: res.data.message,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        props.history.push("/Sucursales");
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.error,
          icon: "error",
        });
      });
  };

  //obtener los campos de la sucursal
  useEffect(() => {
    let url = `/branches/${id}`;
    MethodGet(url)
      .then((res) => {
        guardarBranch(res.data.data);
        guardarEstado({ state_id: res.data.data.state_id });
        guardarMunicipioId({ municipality_id: res.data.data.municipality_id });
        if (res.data.data.image) {
          setImage({
            urlPhoto: res.data.data.image,
            image: res.data.data.image,
          });
        }
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <div onSubmit={handleSubmit(onSubmit)}>
        <form noValidate>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: 100 }}
          >
            {/**
             * identificar Codigo de FORMS
             */}
            <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card>
                <CardHeader color="primary">
                  <h2 className={classes.cardTitleWhite}>
                    Editar Datos de Sucursal
                  </h2>
                  <p className={classes.cardCategoryWhite}>
                    Completa correctamente los datos
                  </p>
                </CardHeader>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Nombre"
                        name="name"
                        autoComplete="name"
                        autoFocus
                        defaultValue={name}
                        error={!!errors.name}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "El Nombre es requerido",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 45,
                            message: "Maximo 45 caracteres",
                          },
                          pattern: {
                            value:
                              /^[A-Záéíóúñ ]+[A-Záéíóúñ ]+[A-Záéíóúñ ]+[A-Záéíóúñ ]$/i,
                            message: "Unicamente carácteres alfabéticos",
                          },
                        })}
                      />
                      <p>{errors?.name?.message}</p>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="direction"
                        label="Direccion"
                        name="direction"
                        autoComplete="direction"
                        autoFocus
                        defaultValue={direction}
                        error={!!errors.direction}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "La Direccion es requerida",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 255,
                            message: "Maximo 255 caracteres",
                          },
                        })}
                      />
                      <p>{errors?.direction?.message}</p>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="number_phone"
                        label="Teléfono"
                        name="number_phone"
                        autoComplete="number_phone"
                        type="number"
                        autoFocus
                        defaultValue={number_phone}
                        error={!!errors.number_phone}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "El Teléfono es requerido",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 10,
                            message: "Maximo 10 digitos",
                          },
                        })}
                      />
                      <p>{errors?.number_phone?.message}</p>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        variant="outlined"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <SelectState
                          estadoId={estadoId}
                          detectarCambiosEstado={detectarCambiosEstado}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        variant="outlined"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <SelectMunicipalities
                          estadoId={estadoId}
                          municipality={municipality}
                          detectarCambiosMunicipios={detectarCambiosMunicipios}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Card profile>
                    <CardAvatar profile>
                      <img
                        src={image.urlPhoto}
                        alt="User"
                        width="100%"
                        height="100%"
                      />
                    </CardAvatar>
                    <CardBody profile>
                      <input
                        className={classes.input}
                        id="icon-button-file"
                        type="file"
                        name="image"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={handleChangeImage}
                      />
                      <label htmlFor="icon-button-file">
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                        >
                          <Tooltip
                            title="seleccionar imagen"
                            aria-label="seleccionar imagen"
                          >
                            <PhotoCamera />
                          </Tooltip>
                        </IconButton>
                      </label>
                      <InputLabel>Selecciona Imagen de la Sucursal</InputLabel>
                      <h2 className={classes.cardTitle}>Editando Sucursal: </h2>
                      <h3 className={classes.cardTitle}>{name} </h3>
                      <p className={classes.description}>
                        Recuerda que la informacion que elimines o modifiques de
                        esta sucursal se actualizaran en todos los registros del
                        sistema.
                      </p>
                    </CardBody>
                  </Card>
                  <Grid container spacing={3} justify="center">
                    <Grid item spacing={3} xs={12} sm={12} md={6}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        className={classes.submit}
                      >
                        ACTUALIZAR
                      </Button>
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </form>
      </div>
    </LayoutDashboard>
  );
}

export default withRouter(OfficeEdit);
